import React, { Component } from 'react'
import { Form } from '@ant-design/compatible'
import '@ant-design/compatible/assets/index.css'
import 'antd4/lib/grid/style/index.css'

import { Button, Alert, Checkbox } from 'hljd'
import { observer } from 'mobx-react'
import style from './index.module.less'

// 协议
import Agreement from './agreement/modal'
const FormItem = Form.Item

@Form.create({
  name: 'liveInfoForm',
  async onFieldsChange(props, values) {
    const keys = Object.keys(values)
    if (keys.includes('extensionBanner')) {
      props.store.getBannerColor(values.extensionBanner)
    }
  }
})
@observer
export default class extends Component {
  handleSubmit = e => {
    e.preventDefault()
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        this.props.store.checkSubmit(values)
      }
    })
  }
  componentDidMount() {
    const {
      params: { id }
    } = this.props
    this.props.store.init(this.props.form.setFieldsValue, id)
  }

  render() {
    const {
      base_components,
      activity_components,
      spread_components,
      from_type,
      live_info,
      agreement,
      showAgreementDetail
    } = this.props.store
    const {
      form: { getFieldDecorator }
    } = this.props
    return (
      <>
        <Form className={style.liveInfo}>
          <div>
            <div className={style.partTitle}>基本信息</div>
            {base_components.map((Item, index) => (
              <Item key={index} {...this.props} />
            ))}
          </div>

          <div>
            <div className={style.partTitle} style={{ marginTop: 60 }}>
              预热物料<span className={style['sub-title']}>
                （直播审核通过后，处于预热状态，预热物料有助于用户提前了解直播信息）
              </span>
            </div>
            {activity_components.map((Item, index) => (
              <Item key={index} {...this.props} />
            ))}
          </div>

          {!this.props.params.id ? (
            <div>
              <div className={style.partTitle} style={{ marginTop: 60 }}>
                直播推广<span className={style['sub-title']}>
                  （直播推广能够大幅度提高直播曝光，为直播引入更多流量同时宣传店铺品牌）
                </span>
              </div>
              {spread_components.map((Item, index) => (
                <Item
                  key={index}
                  {...this.props}
                  type="edit"
                  liveInfo={live_info}
                />
              ))}
            </div>
          ) : from_type && from_type === 1 ? (
            <Alert
              style={{ marginBottom: 20, color: '#FF801A' }}
              message={`本场直播已经设置${live_info.popTime}分钟推广时长`}
              type="warning"
              showIcon
            />
          ) : (
            ''
          )}

          <div className={style.submit}>
            <FormItem label="" className={style.agreement}>
              {getFieldDecorator('agreement', {
                valuePropName: 'checked',
                initialValue: agreement
              })(
                <Checkbox>
                  本人已阅读并同意签署
                  <a href="javascript:void(0);" onClick={showAgreementDetail}>
                    《婚礼纪视频直播服务协议》
                  </a>
                </Checkbox>
              )}
            </FormItem>

            <Button
              type="primary"
              className={style.submitBtn}
              onClick={this.handleSubmit}
            >
              提交审核
            </Button>

            <p className={style.submitTips}>
              注：推广的直播确定后，将在开播前48小时开启预热，预热开启后，不能修改和和删除直播。
            </p>
          </div>
        </Form>
        <Agreement store={this.props.store} form={this.props.form} />
      </>
    )
  }
}
